'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AbstractElement from 'UIComponents/elements/AbstractElement';
import UIClickable from 'UIComponents/button/UIClickable';
import Checkbox from './Checkbox';
import UnstyledNestedNavItem from './UnstyledNestedNavItem';

const getOpenIcon = open => open ? 'up' : 'down';

const NestedNavCheckboxItem = (_ref) => {
  let {
    checkboxProps,
    children,
    className,
    defaultOpen,
    title
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["checkboxProps", "children", "className", "defaultOpen", "title"]);

  const {
    onChange
  } = checkboxProps;
  const [open, setOpen] = useState(defaultOpen);
  const itemClasses = classNames('p-y-0', className, !!children && 'display-flex align-center');
  const handleChange = useCallback(evt => {
    const {
      target: {
        checked
      }
    } = evt;

    if (onChange) {
      onChange(evt);
    }

    if (!evt.defaultPrevented && checked) {
      setOpen(true);
    }
  }, [onChange]);

  const handleClick = evt => {
    evt.stopPropagation();
  };

  const handleOpenChange = ({
    target: {
      value
    }
  }) => {
    setOpen(value);
  };

  const renderedTitle = children ? /*#__PURE__*/_jsx(UIClickable, {
    onClick: evt => {
      evt.preventDefault();
      setOpen(!open);
    },
    children: title
  }) : title;
  return /*#__PURE__*/_jsx(UnstyledNestedNavItem, Object.assign({}, rest, {
    _linkComponent: AbstractElement,
    className: itemClasses,
    iconRight: children != null ? getOpenIcon(open) : null,
    onOpenChange: handleOpenChange,
    open: open,
    title: /*#__PURE__*/_jsx(Checkbox, Object.assign({}, checkboxProps, {
      onChange: handleChange,
      onClick: handleClick,
      alignment: 'center',
      children: renderedTitle
    })),
    children: children
  }));
};

NestedNavCheckboxItem.propTypes = {
  checkboxProps: PropTypes.shape({
    onChange: PropTypes.func
  }),
  children: PropTypes.node,
  className: PropTypes.string,
  defaultOpen: PropTypes.bool,
  title: PropTypes.node.isRequired
};
NestedNavCheckboxItem.defaultProps = {
  checkboxProps: {},
  defaultOpen: false
};
export default NestedNavCheckboxItem;